import { useMemo } from "react";

import { useGetImportLayers } from "fond/hooks/useGetImportLayers";
import { DataPrepStatus } from "fond/project/panels/RunDataPrep/dataPrepStatus";

import { getMuPowerDataPrepStatus, muPowerDataPrepStatusLayerIds } from "./muPowerDataPrepStatus";

/** Return the status of layer groups relevant to MU Power data prep */
export const useMuPowerDataPrepStatus = (versionId: string): DataPrepStatus => {
  const layers = useGetImportLayers(versionId, muPowerDataPrepStatusLayerIds);
  return useMemo(() => getMuPowerDataPrepStatus(muPowerDataPrepStatusLayerIds.filter((id) => !!layers.get(id)?.layer)), [layers]);
};
